import React, { createRef, useEffect } from "react";

import "./pieceIconDisplay.css";
import HeartIcon from "../../assets/icons/heartIcon";
import DownloadIcon from "../../assets/icons/downloadIcon";
import ClockIcon from "../../assets/icons/clockIcon";
import HourglassIcon from "../../assets/icons/hourglassIcon";
import OriginalIcon from "../../assets/icons/originalIcon";
import TranscriptionIcon from "../../assets/icons/transcriptionIcon";

interface PieceIconDisplayProps {
    downloads: number;
    likes: number;
    duration: number;
    year: number;
    original: boolean;
}

export default function PieceIconDisplay(props: PieceIconDisplayProps) {

    const ref = createRef<HTMLDivElement>();

    useEffect(() => {
        window.addEventListener("resize", updateHeight);
        updateHeight();
        setTimeout(updateHeight, 100);
        setTimeout(updateHeight, 400);
        setTimeout(updateHeight, 1100); // Allow time for parent to render
        return () => {
            window.removeEventListener("resize", updateHeight);
        }

    }, [ref]);

    function updateHeight() {
        if(ref.current) {
            if (ref.current && ref.current.parentElement) {
                ref.current.style.height = `${ref.current.parentElement.offsetHeight-40}px`;
                ref.current.style.marginLeft = `calc(${ref.current.parentElement.offsetWidth}px - var(--piece-icon-display-width))`;
            }
        }
    }

    return <div ref={ref} className="piece-icon-display">
        <div className="piece-icon-display-item">
            <HeartIcon/>
            <span>{props.likes}</span>
        </div>
        <div className="piece-icon-display-item">
            <DownloadIcon/>
            <span>{props.downloads}</span>
        </div>
        <div className="piece-icon-display-item">
            <HourglassIcon/>
            <span>{props.duration} min</span>
        </div>
        <div className="piece-icon-display-item">
            <ClockIcon/>
            <span>{props.year}</span>
        </div>
        {props.original && <div className="piece-icon-display-item original">
            {props.original ? <OriginalIcon/> : <TranscriptionIcon/>}
        </div>}
    </div>;
}

export type { PieceIconDisplayProps };